/**
 * Dynamic Hero Images Configuration
 * 
 * This file manages hero images with different sky variations
 * Images are stored in /public/assets/hero for static serving
 */

export const HERO_IMAGES = {
  daylight: {
    src: '/assets/hero/sunmarbella-hero-daylight.webp',
    alt: 'Luxury Rental Marbella - Daylight View',
    description: 'Bright sunny day showcasing the pool and garden'
  },
  sunrise: {
    src: '/assets/hero/sunmarbella-hero-sunrise.webp',
    alt: 'Luxury Rental Marbella - Sunrise View',
    description: 'Golden morning light over the Mediterranean'
  },
  sunset: {
    src: '/assets/hero/sunmarbella-hero-sunset.webp',
    alt: 'Luxury Rental Marbella - Sunset View',
    description: 'Romantic sunset views from the terrace'
  }
} as const;

export type HeroImageType = keyof typeof HERO_IMAGES;

/**
 * Get the appropriate hero image based on time of day
 * @returns HeroImageType - 'daylight', 'sunrise', or 'sunset'
 */
export const getHeroImageByTime = (): HeroImageType => {
  const hour = new Date().getHours();
  
  if (hour >= 5 && hour < 8) return 'sunrise';
  if (hour >= 17 && hour < 21) return 'sunset';
  return 'daylight';
};

/**
 * Get all hero images for manual selection or cycling
 */
export const getAllHeroImages = () => Object.entries(HERO_IMAGES);
